var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"againTicketPurchase"},[_c('div',{staticClass:"order",on:{"click":_vm.orderClick}},[_vm._v("进入订单列表")]),_c('div',{staticClass:"again",on:{"click":_vm.againBuyingTickets}},[_vm._v("重新购票")])])
}
var staticRenderFns = []

export { render, staticRenderFns }